import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Menu } from '../pages/menu/menu';
import { AuthService } from '../authentication/auth-service';
import { CondominiumListService } from '../claims/control/condominium-list-service';
import { IdleTimeoutService } from '../authentication/idle-timeout-service';
import { LocalizationPipePipe } from '../localization/control/localisation-pipe-pipe';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Menu, LocalizationPipePipe],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('claim-manager');

  constructor(private readonly authService: AuthService,
    private readonly condominiumListService: CondominiumListService,
    protected readonly idleTimeoutService: IdleTimeoutService) {
    if (!this.authService.isAuthenticated) {
      this.condominiumListService.clearCache();
    }
    this.authService.user$.subscribe(user => {
      if (!user) {
        this.condominiumListService.clearCache();
      } else {
        this.condominiumListService.getCondominiumList().then();
      }
    })
  }
}
